/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponseData =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/**
 * Standard error response object
 */
export class GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$: GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponseData;

  constructor(
    err: GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name =
      "GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponse";
  }
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponse$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponse(
        v,
      );
    });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponse$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponse$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponse
  > = z.instanceof(
    GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponse,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponse$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponse$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponse$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponse$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdErrorResponse$Outbound;
}
